var magicStyles = [".prefix[data-v-528165e0] {\n  flex-basis: calc(((100% - 8px) * 0.375) + -2px);\n  flex-grow: 0;\n}\n.number[data-v-528165e0] {\n  flex-basis: calc(((100% - 8px) * 0.625) + 2px);\n  flex-grow: 0;\n}"];

export default magicStyles;
